import moment from 'moment';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAssetHistoryById } from '../../../../actions/inventory';
import IconToolTip from '../../../../common/IconToolTip';
import Verticalline from '../../../../common/Verticalline';
import { validateStringValue } from '../../../../utils/common';
import NoResultFound from '../../../../common/NoResultFound';
import { openCustomModal } from '../../../../actions/modal';
import EditAssetDate from './EditAssetHistoryDate';
import { SkeltonCardTwo } from '../../../../common/SkeltonCardTwo';
import { InventoryLocationType } from '../../InventoryController';
import { omit } from 'lodash';


export default function AssetHistory({ assetId }) {
    const assetHistoryData = useSelector((state) => state.inventory.assetHistoryData);
    const assetHistoryLoading = useSelector((state) => state.loading.assetHistoryLoading);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!assetHistoryData[assetId]) {
            dispatch(getAssetHistoryById({ id: assetId }));
        }
    }, [assetId, dispatch]);

    const assetHistory = useMemo(() => {
        let list = [];
        if (assetId && assetHistoryData && assetHistoryData[assetId]) {
            assetHistoryData[assetId].forEach((elem) => {
                let toPush = elem;
                if (elem.milestone) {
                    list.push(omit(elem, ['milestone']));
                    const elemWithoutLocation = omit(elem, ['location']);
                    list.push(elemWithoutLocation);
                } else {
                    list.push(toPush);
                }
            });
        }
        return list;
    }, [assetId, assetHistoryData]);

    if (assetHistoryLoading) {
        return (
            <div className='w-full px-4'>
                <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8]} height={13} />
            </div>
        );
    }

    if (assetHistory.length === 0) {
        return <div className="py-4 px-4" >
            <NoResultFound message="Asset Details Not Found" paddingy="py-2" paddingx="px-2" />
        </div>
    }

    const showAssetInfo = (history) => {
        const { location } = history;
        let Component = <></>;
        let icon = location ? 'warehouse' : 'confirmation_number';

        Component = <>
            {location ? <p>Added on {location.type === InventoryLocationType.SITE ? 'Site' : 'Warehouse'}</p> : null}
            {location?.external_id && (
                <IconToolTip title='Show Assets' placement='bottom'>
                    <a
                        className=' block max-w-290 truncate font-bold  hover:text-scogoorange text-font11 cursor-pointer text-scogobgsky m-0'
                        target='_blank'
                        href={`/inventory?tab=assets&selectedSiteId=${location?.id}`}
                        rel='noreferrer'
                    >
                        {location?.external_id}
                    </a>
                </IconToolTip>
            )}

            {
                history.milestone ? <div>

                    <div className='flex gap-1 font-medium hover:text-scogoorange text-scogobgsky' onClick={() => window.open(`/chats/${history?.milestone?.ticket?.id}?tab=alltickets`, '_blank')}>
                        {/* {history?.milestone?.type ? <span>{history?.milestone?.type?.charAt(0) + history?.milestone?.type?.slice(1).toLowerCase()}</span> : null}
                        <span>Milestone</span> */}
                        {history?.milestone?.ticket?.ticket_number ?
                            <span>{history?.milestone?.ticket?.ticket_number}</span>
                            : null}

                    </div>
                    {history?.milestone?.ticket?.project?.name ? <IconToolTip title={`Project Name : ${history?.milestone?.ticket?.project?.name}`}>
                        <p className='text-scogogray truncate w-full font-normal text-font11'>Project Name : {history?.milestone?.ticket?.project?.name}</p>
                    </IconToolTip> : null}
                    {history?.milestone?.closed_remark ? <IconToolTip title={`Remark : ${history?.milestone?.closed_remark}`}>
                        <p className='text-scogogray truncate w-full font-normal text-font11'>Remark : {history?.milestone?.closed_remark}</p>
                    </IconToolTip> : null}
                </div>
                    : null
            }
        </>

        return { Component, icon };
    };

    return (
        <div className='relative w-full h-full overflow-y-auto'>
            <ul>
                {assetHistory?.map((history, i) => {
                    if (!history.location && !history.milestone) return;

                    return (
                        <li key={history.id} className={`border bottom-2  relative flex flex-row items-center  h-36  ${i % 2 !== 0 ? 'bg-gray-100' : ''}`}>
                            <div className='flex items-center w-full'>
                                <div className='px-4'>
                                    <span
                                        style={{ height: '3.5rem', width: '3.5rem' }}
                                        className='material-icons text-scogoprimary text-font15 border-2 flex items-center justify-center rounded-full  border-scogoprimary'
                                    >
                                        {showAssetInfo(history)?.icon}
                                    </span>
                                </div>
                                <div className={`text-black w-full overflow-hidden text-font12`}>
                                    <p className='truncate cursor-pointer w-11/12'>{showAssetInfo(history)?.Component}</p>
                                    {(history?.milestone?.closed_at || history?.added_on || history?.created_at) ? <span className='text-scogogray font-normal text-font10 '>{moment(history?.milestone?.closed_at || history?.added_on || history.created_at).format('DD/MM/YYYY HH:mm')}
                                    </span> : null}
                                </div>
                            </div>
                            <Verticalline isLast={i + 1 === assetHistory?.length} lineHeight='5.8rem' marginTop='9rem' />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}


